import React, { forwardRef, useEffect, useState } from 'react';

import validate from '@vlabs/shared/validators';
import { Control } from '@vlabs/uikit';

import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';
import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';

import { useEventListFiltersTranslation } from '../../i18n';
import { useEventListFilters } from '../../useEventListFilters';

const validateIds = validate.multipleUuid();

const getIds = (value: string): string[] | undefined => {
  const ids = value
    .split(',')
    .map((id) => id.trim())
    .filter(Boolean);

  if (ids.length === 0) return undefined;
  return ids;
};

function TopSimilarObjectsFilterPopover(
  props: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { t } = useEventListFiltersTranslation();
  const [ids, setIds] = useState('');
  const [error, setError] = useState('');
  const { filters, updateFilters, updateFiltersDebounced } = useEventListFilters();

  const handleChange = (value: string) => {
    setIds(value);

    const validationResult = validateIds(value);
    if (typeof validationResult === 'string') {
      setError(validationResult);
      return;
    }

    setError('');
    updateFiltersDebounced({ top_similar_object_ids: getIds(value) });
  };

  const reset = () => {
    setIds('');
    setError('');
    updateFilters({ top_similar_object_ids: undefined });
  };

  useEffect(() => {
    setIds(filters.top_similar_object_ids?.join(',') ?? '');
  }, [filters.top_similar_object_ids]);

  return (
    <PopoverWithButton
      {...props}
      isButtonDisabled={filters.top_similar_object_ids === undefined}
      onClickReset={reset}
      ref={ref}
      title={<div className="Subtitle-2">{t('top_similar_object_ids')}</div>}
    >
      <Control.Input
        errorMessage={error}
        hasError={!!error}
        id="top_similar_object_ids"
        isClearable
        name="top_similar_object_ids"
        onChangeValue={handleChange}
        onClear={reset}
        value={ids}
      />
    </PopoverWithButton>
  );
}

const TopSimilarObjectsFilterPopoverWithRef = forwardRef(TopSimilarObjectsFilterPopover);
export { TopSimilarObjectsFilterPopoverWithRef as TopSimilarObjectsFilterPopover };
